import type { Role } from '@pulsepoint/shared';

export const ROLE_INFO: Record<Role, { label: string; description: string }> = {
  admin: { label: 'Admin', description: 'Infinity EV. Everything, across all organisations: chargers, prices, settings and people.' },
  manager: { label: 'Manager', description: 'Looks after their organisation’s drivers and RFID cards. Sees chargers and prices read only, and can ask a charger for its status. Can’t change chargers or prices.' },
  user: { label: 'User', description: 'Read only: their organisations, chargers’ live status, sessions and reports. Changes nothing.' },
};
